module.exports = __webpack_public_path__ + "img/history-2018.106fe3a4.jpg";